import CrudBase from "src/components/CrudBase";
import { useTranslation } from "react-i18next";
import ModulesForm from "./ModulesForm";
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';

export function Modules() {
    const { t } = useTranslation();

    return (
        <CrudBase
            resource="modules"
            indexColumns={['name', 'municipality', 'active', 'opening_time', 'closing_time']}
            customColumns={
                {
                    'municipality': (municipality) => municipality.name,
                    'active': (active) => parseInt(active) ? t("GENERAL.ENABLE") : t("GENERAL.DISABLED")
                }
            }
            showButton={false}
            form={ModulesForm}
            search={true}
            deleteButton={false}
            icon={<MeetingRoomIcon fontSize="large" />}
        />
    );
}
